import { render, staticRenderFns } from "./BlockHeader.vue?vue&type=template&id=640d95a2&"
import script from "./BlockHeader.vue?vue&type=script&lang=js&"
export * from "./BlockHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('640d95a2')) {
      api.createRecord('640d95a2', component.options)
    } else {
      api.reload('640d95a2', component.options)
    }
    module.hot.accept("./BlockHeader.vue?vue&type=template&id=640d95a2&", function () {
      api.rerender('640d95a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/lib/vue/components/modules/BlockHeader.vue"
export default component.exports